interface Props {
  label: string;
  detail: string;
}

export default function UnavailableAction({ label, detail }: Props) {
  return (
    <div className="unavailable-action">
      <div>
        <strong>{label}</strong>
        <p>{detail}</p>
      </div>
      <button className="btn btn-secondary" type="button" disabled>
        Coming later
      </button>
    </div>
  );
}
